import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface MatchCreationConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  profile1Name: string;
  profile2Name: string;
  isAdmin: boolean;
}

export function MatchCreationConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  profile1Name,
  profile2Name,
  isAdmin,
}: MatchCreationConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {isAdmin && <AlertTriangle className="h-5 w-5 text-amber-500" />}
            Create Match?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Are you sure you want to create a match between{" "}
              <strong>{profile1Name}</strong> and <strong>{profile2Name}</strong>?
            </p>
            {isAdmin && (
              <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-md p-3">
                <p className="text-amber-900 dark:text-amber-100 font-semibold text-sm flex items-center gap-2">
                  <AlertTriangle className="h-4 w-4" />
                  NOTE: Admins are not supposed to create matches
                </p>
                <p className="text-amber-800 dark:text-amber-200 text-xs mt-1">
                  Admin accounts have this capability for testing and emergency situations only.
                  Will you still proceed?
                </p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {isAdmin ? "Proceed Anyway" : "Create Match"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
